var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolTip-container"},[_c('div',{class:'inner tooltip_' + _vm.type},[_c('i',{class:'icon iconfont '+ _vm.iconMap[_vm.type]}),_vm._v(" "+_vm._s(_vm.msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }